import React from 'react';
import { View, StyleSheet, ImageSourcePropType } from 'react-native';
import { Text, Card, CardContainer, CardCaption, Shape, Colors, getSpacing, getRadius, Image } from '@rahtab/ui';
import { withToman } from '@rahtab/system/lib/tools/string';

const defaultMerchandise = require('assets/images/defaultMerchandise.png');

const SaleItem: React.FC<SaleItemProps> = ({ itemAmount, customerName, date, time, price, itemName, via }) => {
  return (
    <Card style={styles.card}>
      <CardCaption style={styles.cardCaption}>
        {/* <Text color="description" margin="none">
          شناسه تراکنش:
          <Text margin="none"> {id}</Text>
        </Text> */}
        <Text margin="none">
          {date} | {time}
        </Text>
      </CardCaption>
      <CardContainer>
        <View style={styles.titleAndVia}>
          <Text>
            خریدار:
            <Text color="secondary"> {customerName}</Text>
          </Text>
          {/* <Text color="description">
            فروش با
            <Text> {via}</Text>
          </Text> */}
        </View>
        <View style={styles.imageAndDetailsView}>
          <Image style={styles.logo} source={defaultMerchandise} variant="outlined" />
          <View>
            <Text color="primary" variant="cardTitle">
              {itemName}
            </Text>
            <Text color="description">
              تعداد:
              <Text margin="none"> {itemAmount}</Text>
            </Text>
            <Text margin="none" color="description">
              قیمت:
              <Text margin="none"> {withToman(price)}</Text>
            </Text>
          </View>
        </View>
      </CardContainer>
    </Card>
  );
};

export default SaleItem;

const styles = StyleSheet.create({
  card: {
    marginVertical: getSpacing(0.5),
    marginHorizontal: getSpacing(),
  },
  cardCaption: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  titleAndVia: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  logo: {
    height: 70,
    width: 70,
  },
  imageAndDetailsView: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});

export interface SaleItemProps {
  id?: string;
  date?: string;
  time?: string;
  customerName?: string;
  via?: string;
  itemName?: string;
  itemAmount?: number;
  price?: number;
  imageUrl?: ImageSourcePropType;
}
